/**
 * NAOKO — odtwarzanie video w karcie produktu na hover (desktop).
 *
 * Markup (snippets/product-card-naoko.liquid):
 *   <div class="pc-card__media">
 *     ...
 *     <video class="pc-card__image pc-card__image--hover pc-card__video" muted loop playsinline preload="none">...
 *
 * Delegacja na document → działa także dla kart doładowanych infinite-scrollem.
 * Wejście kursora na .pc-card__media → video.play(); opuszczenie → pause() + reset.
 * preload="none" w markupie => video ładuje się dopiero przy pierwszym hover.
 * Widoczność (opacity) steruje CSS (.pc-card__image--hover na :hover); tu tylko playback.
 */
(function () {
  if (window.__naokoCardVideoHoverInit) return;
  window.__naokoCardVideoHoverInit = true;

  // Tylko urządzenia z hoverem (desktop). Na mobile efekt jest nieaktywny.
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  document.addEventListener('mouseover', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var media = target.closest('.pc-card__media');
    if (!media) return;
    var video = media.querySelector('.pc-card__video');
    if (video && video.paused) {
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }
  });

  document.addEventListener('mouseout', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var media = target.closest('.pc-card__media');
    if (!media) return;
    // Ignoruj ruch w obrębie tej samej karty (mouseout odpala przy przejściu między dziećmi).
    if (event.relatedTarget && media.contains(event.relatedTarget)) return;
    var video = media.querySelector('.pc-card__video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });
})();
